import {
  byUserInteraction, initLazyLoad, isElementOnScreen, sendGoogleEvent, sendRequest,
} from '@html/_common/utils';

const EVENT_CATEGORY = 'Recommended destinations';
const LOADING_SPINNER_CLASS_JS = '.js-ao-clp-recommended-destinations__loading-spinner';
const DESTINATIONS_SECTION_CLASS_JS = '.js-ao-clp-recommended-destinations';
const LOADING_SECTION_CLASS = 'ao-clp-recommended-destinations--loading';

export default function AOClpRecommendedDestinations() {
  const load = ($recommendedDestination) => {
    const $loadingSpinner = $recommendedDestination.find(LOADING_SPINNER_CLASS_JS);
    const postParameters = {
      limit: $recommendedDestination.data('item-count'),
      omparam: $recommendedDestination.data('omparam'),
      layout: $recommendedDestination.data('layout'),
    };

    sendRequest(
      '/api/content-pages/get-recommended-destinations',
      postParameters,
      (data) => {
        if (data.status === 'OK') {
          const $recommendationsElement = $(data.html);

          $loadingSpinner.after($recommendationsElement);
          $loadingSpinner.remove();

          initLazyLoad();
          $recommendedDestination.removeClass(LOADING_SECTION_CLASS);
        }
      },
    );
  };

  const initiateTracking = () => {
    $('body').on('click', '.js-ao-clp-recommended-destinations__item-image', (event) => {
      const $clickedElement = $(event.currentTarget);
      const $clickedElementListItem = $clickedElement.parent();
      const clickedElementLink = $clickedElement.attr('href');

      if (typeof clickedElementLink === typeof undefined || clickedElementLink === false) {
        return;
      }

      sendGoogleEvent(
        EVENT_CATEGORY,
        clickedElementLink,
        `Index: ${$clickedElementListItem.index() + 1}`,
      );
    });
  };

  const initiate = () => {
    const $recommendedDestinations = $(DESTINATIONS_SECTION_CLASS_JS);

    if ($recommendedDestinations.length) {
      $recommendedDestinations.each((index, recommendedDestination) => {
        const $recommendedDestinationSection = $(recommendedDestination);
        if (isElementOnScreen($recommendedDestinationSection)) {
          load($recommendedDestinationSection);
        } else {
          byUserInteraction('load-recommended-tours', () => {
            load($recommendedDestinationSection);
          });
        }
      });
    }

    initiateTracking();
  };

  return { initiate };
}
